import EllipsisCellRenderer from './EllipsisCellRenderer';

export const SentToCellRenderer = props => {
    const { value } = props;
    const resolvedValue = (value || []).join(', ');

    return <EllipsisCellRenderer value={resolvedValue} />;
};
